import { render, staticRenderFns } from "./WizardNavigationFrame.vue?vue&type=template&id=32f638a0&scoped=true&"
import script from "./WizardNavigationFrame.vue?vue&type=script&lang=js&"
export * from "./WizardNavigationFrame.vue?vue&type=script&lang=js&"
import style0 from "./WizardNavigationFrame.vue?vue&type=style&index=0&id=32f638a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f638a0",
  null
  
)

export default component.exports